import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

const AnimatedLoader = ({ containerStyle = { width: '100%', height: '100%' } }) => {
  return (
    <ContentLoader
      style={{
        ...containerStyle,
        ...{
          width: (containerStyle && containerStyle.width) || '100%',
          height: (containerStyle && containerStyle.height) || '100%',
        },
      }}
    >
      <rect x="0" y="0" rx="5" ry="5" width="100%" height="100%" />
    </ContentLoader>
  );
};

AnimatedLoader.propTypes = {
  containerStyle: PropTypes.instanceOf(Object),
};

AnimatedLoader.defaultProps = {
  containerStyle: {
    width: '100%',
    height: '100%',
  },
};

export default AnimatedLoader;
